import React, { useState } from 'react';
import DetailExpandableItem, { DetailExpandableItemProps } from '../detail-expandable-item/detail-expandable-item';
import { DetailExpandableListWrapper, ListTitle, ShowMoreButton } from './detail-expandable-list.style';

export interface DetailExpandableListProps {
    eleId?: string;
    listTitle: string;
    data: DetailExpandableItemProps[];
}

const DetailExpandableList: React.FC<DetailExpandableListProps> = ({ eleId, listTitle, data }) => {
    const [showAll, setShowAll] = useState(false);
    const shouldShowButton = data.length > 3;
    const displayData = showAll ? data : data.slice(0, 3);

    const toggleShowAll = () => {
        setShowAll(!showAll);
    };

    if (!data || data.length === 0) {
        return null;
    }

    return (
        <DetailExpandableListWrapper id={eleId}>
            <ListTitle>{listTitle}</ListTitle>
            {displayData.map((item) => (
                <DetailExpandableItem
                    key={item.id}
                    id={item.id}
                    title={item.title}
                    description={item.description}
                />
            ))}
            {shouldShowButton && (
                <ShowMoreButton onClick={toggleShowAll}>
                    {showAll ? (
                        <>
                            Show less <span className="icon icon--chevron-up" aria-hidden="true" />
                        </>
                    ) : (
                        <>
                            Show more <span className="icon icon--chevron-down" aria-hidden="true" />
                        </>
                    )}
                </ShowMoreButton>
            )}
        </DetailExpandableListWrapper>
    );
};

export default DetailExpandableList;
